import axios from 'axios'

axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const controller = 'UserManagement'

export const getUserAccounts = async () => await axios.get(`/${controller}/UserAccounts`)
